import React from 'react';
import FormWrapper from './FormWrapper';


const FormButton = function (props) {
  const {
    text, ...rest
  } = props;
  return (
    <FormWrapper {...rest}><button className="button" >{text}</button></FormWrapper>
  );
};

export default FormButton;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormButton.js